import { Folder } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogClose } from '../ui/dialog';
import { FOLDER_COLORS } from '../sidebar/constants';

const CreateFolderDialog = ({
  open,
  onOpenChange,
  folderName,
  setFolderName,
  folderColor,
  setFolderColor,
  onSubmit,
  loading
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md dark:bg-slate-800 dark:border-slate-700">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 dark:text-gray-100">
            <Folder className="w-5 h-5 text-[#4A9CC7]" />
            Create New Folder
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="folder-name" className="dark:text-gray-300">Folder Name</Label>
            <Input
              id="folder-name"
              value={folderName}
              onChange={(e) => setFolderName(e.target.value)}
              placeholder="My Folder"
              data-testid="folder-name-input"
              onKeyDown={(e) => e.key === 'Enter' && onSubmit()}
              className="dark:bg-slate-900 dark:border-slate-600"
            />
          </div>
          <div className="space-y-2">
            <Label className="dark:text-gray-300">Color</Label>
            <div className="flex gap-2 flex-wrap">
              {FOLDER_COLORS.map(color => (
                <button
                  key={color}
                  onClick={() => setFolderColor(color)}
                  className={`w-8 h-8 rounded-lg transition-all ${
                    folderColor === color ? 'ring-2 ring-offset-2 ring-gray-400 dark:ring-offset-slate-800 scale-110' : 'hover:scale-105'
                  }`}
                  style={{ backgroundColor: color }}
                />
              ))}
            </div>
          </div>
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline" className="dark:border-slate-600 dark:text-gray-300">Cancel</Button>
          </DialogClose>
          <Button 
            onClick={onSubmit}
            disabled={loading || !folderName.trim()}
            className="bg-[#4A9CC7] hover:bg-[#3d8ab5]"
            data-testid="create-folder-btn"
          >
            {loading ? 'Creating...' : 'Create Folder'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CreateFolderDialog;
